import React, {Component} from 'react'
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl'

class CalculatorTermForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            name: '',
            simulation: '',
            calculatorTermId: '',
            variableName: '',
            index: 0,
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.deleteValue = this.deleteValue.bind(this)
        this.changeValue = this.changeValue.bind(this)
    }

    componentDidMount() {
        const value =  this.props.value || {}
        this.setState({
            name: value.name || '',
            calculatorTermId: value.calculatorTermId || '',
            variableName: value.variableName || '',
            index: this.props.index || 0
        })
    }

    componentWillReceiveProps(nextProps) {
        const value =  nextProps.value || {}
        this.setState({
            name: value.name || '',
            calculatorTermId: value.calculatorTermId || '',
            variableName: value.variableName || '',
            index: nextProps.index || 0
        })
    }

    handleFormChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        }, () => {
            this.changeValue()
        })
    }

    deleteValue(e) {
        e.preventDefault()
        const onDelete = this.props.onDelete || function() {}
        onDelete(this.state.index)
    }

    changeValue() {
        const onChange = this.props.onChange || function() {}
        onChange(this.state.index, {
            name: this.state.name,
            simulation: this.state.simulation,
            calculatorTermId: this.state.calculatorTermId,
            variableName: this.state.variableName,
        })
    }

    render() {
        const messages = defineMessages({
            "name_placeholder": {
                id: 'product.edit.form.calculator.term.item_name_placeholder',
                defaultMessage: 'Parameter name',
            },
            "simulation_placeholder": {
                id: 'product.edit.form.calculator.term.item_simulation_placeholder',
                defaultMessage: 'Simulation value',
            },
        })
        return (
            <div className="row p-2">
                <div className="col-12 py-2 bg-clean rounded">
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group">
                                <label>
                                    <FormattedMessage
                                        id="product.edit.form.calculator.term.item_name_label"
                                        defaultMessage="Constraint name"
                                    />
                                </label>
                                <input
                                    name="name"
                                    value={this.state.name}
                                    onChange={this.handleFormChange}
                                    type="text"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages['name_placeholder'])}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <button className="btn btn-danger btn-sm" onClick={this.deleteValue}>
                                <FormattedMessage
                                    id="product.edit.form.calculator.term.remove_btn"
                                    defaultMessage="Remove"
                                />
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default injectIntl(CalculatorTermForm)


// WEBPACK FOOTER //
// ./src/product/form/calculator/term.component.jsx